import {getData,postData} from '@/assets/js/api.js'

//创建任务 - 项目
// params{
//   "TaskName": "string",
//   "Start": true
// }
export const CreateAllTask = (params,fn) => {
	let methods = '/api/OTA/CreateAllTaskV2';
	postData(methods, params, 1, fn);
};

//创建任务 - SKU
// params{
//   "TaskName": "string",
//   "GpNo": 0,
//   "ClassSkuList": ["ClassSku"],
//   "Start": true
// }
export const CreateMulticastTask = (params,fn) => {
	let methods = '/api/OTA/CreateMulticastTaskV2';
	
	return postData(methods, params, 1, fn);
};

//创建任务 - 设备
// params{
//   "TaskName": "string",
//   "VDeviceList": ["DeviceId"],
//   "Start": true
// }
export const CreateUnicastTask = (params,fn) => {
	let methods = '/api/OTA/CreateUnicastTaskV2';
	postData(methods, params, 1, fn);
};

//获取任务是否Check
export const CheckTask = (params,fn) => {
	let methods = '/api/OTA/CheckTask';
	getData(methods, params, 1, fn);
};

//获取当前可OTA升级的设备数量
export const FindUpgradeDeviceCount = (params,fn) => {
	let methods = '/api/OTA/FindUpgradeDeviceCountV2';
	getData(methods, params, 1, fn);
};

//获取项目可升级类型列表
export const FindUpgradeDeviceTypeList = (params,fn) => {
	let methods = '/api/OTA/FindUpgradeDeviceTypeListV2';
	getData(methods, params, 1, fn);
};

//获取已有任务列
export const FindTaskList = (params,fn) => {
	let methods = '/api/OTA/FindTaskList';
	getData(methods, params, 1, fn);
};

//获取指定任务
export const FindTask = (params,fn) => {
	let methods = '/api/OTA/FindTask';
	getData(methods, params, 1, fn);
};

//指定任务 - 开启
export const Start = (params,fn) => {
	let methods = '/api/OTA/Start';
	getData(methods, params, 1, fn);
};

//指定任务 - 暂停
export const Stop = (params,fn) => {
	let methods = '/api/OTA/Stop';
	getData(methods, params, 1, fn);
};

//指定任务 - 删除
export const Delete = (params,fn) => {
	let methods = '/api/OTA/Delete';
	getData(methods, params, 1, fn);
};

//获取指定SKU列 （按SKU）
export const FindOtaClassSkuListByCategory = (params,fn) => {
	let methods = '/api/OTA/FindOtaClassSkuListByCategoryV2';
	getData(methods, params, 1, fn);
};

//获取指定设备列 （按区域）
export const FindOtaClassSkuListByArea = (params,fn) => {
	let methods = '/api/OTA/FindOtaClassSkuListByAreaV2';

	return getData(methods, params, 1, fn);
};

//获取创建任务 - SKU（消耗时间）
// {
//   "Result": 0,
//   "StatusCode": 0,
//   "Message": "string"
// }
export const CalculateMulticastTaskUpgradeTime = (params,fn) => {
	let methods = '/api/OTA/CalculateMulticastTaskUpgradeTimeV2';
	return postData(methods, params, 1, fn);
};

//获取创建任务 - 设备（消耗时间）
// {
//   "Result": 0,
//   "StatusCode": 0,
//   "Message": "string"
// }
export const CalculateUnicastTaskUpgradeTime = (params,fn) => {
	let methods = '/api/OTA/CalculateUnicastTaskUpgradeTimeV2';
	postData(methods, params, 1, fn);
};

//获取创建任务 - 设备（消耗时间）
// {
//   "Result": 0,
//   "StatusCode": 0,
//   "Message": "string"
// }
export const CalculateAllTaskUpgradeTime = (params,fn) => {
	let methods = '/api/OTA/CalculateAllTaskUpgradeTimeV2';
	getData(methods, params, 1, fn);
};

export const ChangeOtaStartTime = (params,fn) => {
	let methods = '/api/ota/ChangeOtaStartTime';
	
	return postData(methods, params, 1, fn);
};

//查找所有的待升级任务
export const searchOTAListOptimize = (params,fn) =>{
	 let methods = '/api/OTA/GetOtaDeviceListWithGroup';
	 return postData(methods, params, 1, fn);
}
